// entities/combo/api/apiCombo.ts — HTTP API for combo slice

import { consola } from 'consola'
import type { GetCombosResponse, AddComboToCartRequest, AddComboToCartResponse, ComboSelection } from '../model/types'
import { useApi } from '@shared/api'

class APICombo {
  getCombosForBranch(branchId: string | number) {
    return useApi(true).get<GetCombosResponse>(`/combos/${branchId}`)
  }

  addComboToCart(
    comboId: string | number,
    branchId: string | number,
    quantity: number,
    selections: ComboSelection[],
  ) {
    const payload: AddComboToCartRequest = {
      combo_id: Number(comboId),
      branch_id: Number(branchId),
      quantity: Number(quantity),
      selections: selections.map((sel) => ({
        group_id: Number(sel.group_id),
        product_ids: sel.product_ids.map(Number),
      })),
    }

    consola.withTag('api-combo').debug('addComboToCart payload:', payload)

    return useApi(true).post<AddComboToCartResponse>('/cart/combo', payload)
  }
}

export const apiCombo = new APICombo()
export default apiCombo
